import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { QuaiManager_DropDownCaret } from '@app/styles';
import { PrognosisRateTypeLabelMap, PrognosisRateTypes, PrognosisValueLabelMap, PrognosisValues } from '@app/dp-shared';
export const Props_PrognosisValueDropDown = {
    adapter: () => SimpleListAdapter([...PrognosisValues], value => _jsx(_Fragment, { children: PrognosisValueLabelMap[value.item] })),
    placeholder: 'Pick Prognosis Value',
    caret: QuaiManager_DropDownCaret,
};
export const DropDown_PrognosisValue = TS_DropDown.prepare(Props_PrognosisValueDropDown);
export const Props_PrognosisRateType = {
    adapter: () => SimpleListAdapter([...PrognosisRateTypes], type => _jsx(_Fragment, { children: PrognosisRateTypeLabelMap[type.item] })),
    placeholder: 'Pick Rate Type',
    caret: QuaiManager_DropDownCaret,
};
export const DropDown_PrognosisRateType = TS_DropDown.prepare(Props_PrognosisRateType);
//# sourceMappingURL=ui-components.js.map